<template>
    <div>
          <v-expansion-panels
            focusable
            class="content"
            style="font-size:12px !important;"
          >
            <v-expansion-panel v-for="(item, i) in ItemUnitsObject" :key="i">
              <v-expansion-panel-header style="padding:5px !important" expand-icon="">
                <div v-on:click="$event.stopPropagation()">
                
                  <v-row no-gutters class="pending" style="padding-top:10px;" @click="SelectItem(i)">
                    <v-col
                      cols="6"
                      sm="6"
                      class="location"
                      style="font-size:12px !important"
                    >
                      <label> <v-icon style="color: #1976d2;font-size:18px !important">mdi mdi-code-array</v-icon>{{item.ItemCode}}</label>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      class="locationnew"
                      style="font-size:12px !important;text-align: right;"
                    >
                       <label> <v-icon style="color: #1976d2;font-size:18px !important">mdi mdi-barcode</v-icon>&nbsp;{{item.Barcode}}</label> 
                    </v-col>
                    <v-col
                      cols="8"
                      sm="8"
                      class="location"
                      style="font-size:12px !important;margin-top: 5px;"
                    >
                      <label>{{item.ItemName}} </label>
                    </v-col>
                    <v-col
                      cols="4"
                      sm="4"
                      class="locationnew"
                      style="font-size:12px !important;margin-top: 5px;text-align: right;"
                    >
                    <label>{{ item.Unit}} ({{ item.Conversion }} {{ ItemUnitsObject[0].Unit }})</label
                      >&nbsp;&nbsp;&nbsp;
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-header>
           
            </v-expansion-panel>
          </v-expansion-panels>
    </div>
  
  </template>
  <script>
  export default {
    data() {
      return {
      };
    },
    props: ['ItemUnitsObject'],
    created(){
           
              
    },
    mounted()
    {
       
    },
    methods: {
      SelectItem(id)
      {
             this.$emit('data-transmitted', id);
      }
    },
    computed: {
   
    },
    
    
  };
  </script>
  